import React, { useRef } from "react";
import { DatePicker } from "antd";
import useIsMobile from "../../hooks/useIsMobile";
import { MOBILE_DATE_PICKER_PROPS } from "../IpEMR/Nurse/CareItems/nurseCareMobilePickerProps";
import "./MobileDatePicker.css";


const MobileDatePicker = ({ ...rest }) => {
  const isMobile = useIsMobile();
  const wrapRef = useRef(null);

  if (!isMobile) {
    return <DatePicker {...MOBILE_DATE_PICKER_PROPS} {...rest} />;
  }

  return (
    <span ref={wrapRef} className="curengo-inline-picker-wrap">
      <DatePicker
        {...rest}
        inputReadOnly
        popupClassName="curengo-inline-picker"
        getPopupContainer={() => wrapRef.current || document.body}
      />
    </span>
  );
};

export default MobileDatePicker;
